import type { Position } from '../types';

// 청산: 잔액 + 포지션 평가액 ≤ 0
// liqLevPct = -(cash + amount) / amount → rawPct = liqLevPct / leverage
export function liqPriceFor(pos: Position, cash: number): number | null {
  if (pos.amount <= 0) return null;
  const liqLevPct = -(cash + pos.amount) / pos.amount;
  const rawPct = liqLevPct / pos.leverage;
  const p = pos.entryPrice * (1 + rawPct);
  return p > 0 ? p : null;
}
